import React from "react";
import { Table } from "react-bootstrap";
import ReactCountryFlag from "react-country-flag";
import { useLocation, useNavigate } from "react-router-dom";
import { OverallRank } from "../../../types/model";
import getCountryISO2 from "country-iso-3-to-2";

interface RankingTableProps {
	gender: string;
	rankings: OverallRank[] | null;
}

const RankingTable: React.FC<RankingTableProps> = ({ gender, rankings }) => {
	const navigate = useNavigate();
	const location = useLocation();

	if (!rankings) return null;

	const filteredRankings = rankings.filter(
		(ranking: OverallRank) => ranking?.rider_gender === gender,
	);

	return (
		<div
			className="bg-secondary text-light p-3 rounded"
			style={{ maxHeight: "40dvh", overflowY: "auto" }}
		>
			<Table
				striped
				hover
				size="sm"
				className="bg-secondary text-light rounded-3"
			>
				<thead>
					<tr>
						<th className="border-0 text-info bg-secondary text-center">
							Rank
						</th>
						<th className="border-0 text-info bg-secondary">Rider Name</th>
						<th className="border-0 text-info bg-secondary">Points</th>
					</tr>
				</thead>
				<tbody>
					{filteredRankings.map((ranking, index) => (
						<tr key={index}>
							<td className="border-0 text-light bg-secondary px-3 align-middle text-center">
								{index + 1}
							</td>
							<td className="border-0 text-info bg-secondary">
								<ReactCountryFlag
									countryCode={getCountryISO2(
										(ranking.rider_country ?? "").toUpperCase().trim(),
									)}
									svg
									style={{ width: "3.5rem" }}
								/>
								<button
									type="button"
									className="btn btn-link p-0 align-baseline text-decoration-none text-info"
									onClick={() => {
										if (ranking.riderId) {
											navigate(`/riders/${ranking.riderId}`, {
												state: {
													fromPath: location.pathname,
													fromLabel: "Rankings",
												},
											});
										}
									}}
									disabled={!ranking.riderId}
									style={{ lineHeight: "inherit" }}
								>
									{`${ranking.rider_first_name} ${ranking.rider_last_name}`}
								</button>
							</td>
							<td className="border-0 text-info bg-secondary">
								{ranking.total_points}
							</td>
						</tr>
					))}
				</tbody>
			</Table>
		</div>
	);
};

export default RankingTable;
